import { fallbackPages, fallbackBehandlinger, fallbackPriser } from "../data";

const API_BASE_URL = "https://api.dev.auxo.dk/public/content";

export async function fetchPages() {
  try {
    const response = await fetch(`${API_BASE_URL}/pages`);
    if (!response.ok) {
      throw new Error(`Fejl ved indlæsning af sider: ${response.statusText}`);
    }
    const data = await response.json();
    return data && data.length > 0 ? data : fallbackPages;
  } catch (error) {
    console.warn("Kunne ikke hente sider fra CMS, bruger fallback data:", error);
    return fallbackPages;
  }
}

export async function fetchBehandlinger() {
  try {
    const response = await fetch(`${API_BASE_URL}/behandlinger`);
    if (!response.ok) {
      throw new Error(`Fejl ved indlæsning af behandlinger: ${response.statusText}`);
    }
    const data = await response.json();
    const list = data && data.length > 0 ? data : fallbackBehandlinger;
    
    // Sort treatments: Fodbehandling first, then Fodbehandling med Neglelak, then others
    const preferredOrder = [
      "fodbehandling",
      "fodbehandling-med-neglelak-eller-gel",
      "fodbehadling-med-neglelak-eller-gel",
      "fodvortebehandling",
      "behandling-af-ligtorne"
    ];
    
    return [...list].sort((a, b) => {
      const indexA = preferredOrder.indexOf(a.treatment_slug);
      const indexB = preferredOrder.indexOf(b.treatment_slug);
      
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.title.localeCompare(b.title);
    });
  } catch (error) {
    console.warn("Kunne ikke hente behandlinger fra CMS, bruger fallback data:", error);
    
    const preferredOrder = [
      "fodbehandling",
      "fodbehandling-med-neglelak-eller-gel",
      "fodbehadling-med-neglelak-eller-gel",
      "fodvortebehandling",
      "behandling-af-ligtorne"
    ];
    
    return [...fallbackBehandlinger].sort((a, b) => {
      const indexA = preferredOrder.indexOf(a.treatment_slug);
      const indexB = preferredOrder.indexOf(b.treatment_slug);
      
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.title.localeCompare(b.title);
    });
  }
}

export async function fetchPriser() {
  try {
    const response = await fetch(`${API_BASE_URL}/priser`);
    if (!response.ok) {
      throw new Error(`Fejl ved indlæsning af priser: ${response.statusText}`);
    }
    const data = await response.json();
    if (data && data.length > 0) {
      return [...data].sort((a, b) => {
        const sortA = a.sortering !== undefined && a.sortering !== null ? a.sortering : 999;
        const sortB = b.sortering !== undefined && b.sortering !== null ? b.sortering : 999;
        return sortA - sortB;
      });
    }
    return fallbackPriser;
  } catch (error) {
    console.warn("Kunne ikke hente priser fra CMS, bruger fallback data:", error);
    return [...fallbackPriser].sort((a, b) => {
      const sortA = a.sortering !== undefined && a.sortering !== null ? a.sortering : 999;
      const sortB = b.sortering !== undefined && b.sortering !== null ? b.sortering : 999;
      return sortA - sortB;
    });
  }
}
